// --------------------------------------------------------------------------
// Save entered email for 'Forgotten password' page
// --------------------------------------------------------------------------
// Author:      RSPB
// Version:     1
// --------------------------------------------------------------------------

'use strict';

var $ = require('jquery');

module.exports = function (options) {
    var context = options.context,
        email,
        forgotPasswordHref;

    function init() {
        forgotPasswordHref = context.find('.link').attr('href');

        context.find('input[name="UserName"]').on('keyup', function (e) {
            email = e.target.value;
            context.find('.link').attr('href', email.length ? forgotPasswordHref + '?UserName=' + email : forgotPasswordHref);
        });
    }

    return {
        init: init
    };
};


//////////////////
// WEBPACK FOOTER
// ./src/scripts/modules/login-page.js
// module id = 515
// module chunks = 0